import { CardDeck as _CardDeck, CardDeckProps as _CardDeckProps } from "reactstrap";

    export const CardDeck = _CardDeck;
    export type CardDeckProps = _CardDeckProps;
    